const HOSTNAME = "https://api.daedalusfund.com";
// const HOSTNAME = "http://localhost:7890";

export { HOSTNAME };
